import { Observable } from 'rxjs';
import { SessionService } from '@app/session/session.service';
import { Params } from '@angular/router';
import { ICrumbsConfig } from '@app/ti-components/study-start-up/bread-crumbs/bread-crumbs.models';

export enum EntityType {
  Country,
  IRB,
  Sites,
  Amendment,
}

export interface ICommonDataProtocol {
  name: string;
  value: number | string;
  topicId: number | string;
  type: EntityType;
}

export interface ICommonMethodOfDataReceipt {
  getEntity(
    searchText: string,
    sessionService: SessionService,
    queryParams: Params,
    limit?: number,
  ): Observable<ICommonDataProtocol[]>;
}

export type ICrumbsDataSource = (
  searchText: string,
  limit?: number,
  config?: ICrumbsConfig,
) => Observable<ICrumbsDataItem[]>;

export interface ICrumbsDataItem {
  name: string;
  url: string;
  icon?: string;
  entityNameTooltip?: string;
  entityNameSubtext?: string;
}
